/* hs-eslint ignored failing-rules */

'use es6';

import I18n from 'I18n';
import { isEmpty } from 'underscore';
import * as FormsService from 'FormsUI/api/Forms';
import { deleteFormDraft as removeFormDraft } from 'FormsUI/api/FormDrafts';
import { fetchFormDefinition } from './FormDefinition';
import { trackEditorInteraction } from 'FormsUI/utils/TrackingUtils';
import { deleteCollectedForm } from 'FormsUI/api/CollectedForms';
import * as LeadFlowsService from 'FormsUI/api/LeadFlows';
import { getRedirectUrl, getIsExternalEditor } from 'FormsUI/utils/QueryParams';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { FormErrors, parseFormError } from 'FormsUI/api/Forms';
import { DELETE_UNPUBLISHED_CHANGES } from 'FormsUI/constants/TrackingInteractionKeys/Editor/Global';
function createAction(name) {
  return `@@formDeletion/${name}`;
}
export const REQUEST_FORM_DELETION = createAction('REQUEST_FORM_DELETION');
export const SUCCEED_DELETING_FORM = createAction('SUCCEED_DELETING_FORM');
export const FAIL_DELETING_FORM = createAction('FAIL_DELETING_FORM');
export const RESET_FORM_DELETION_STATE = createAction('RESET_FORM_DELETION_STATE');
const SUCCEED_DELETING_FORM_DRAFT = createAction('SUCCEED_DELETING_FORM_DRAFT');
const FAIL_DELETING_FORM_DRAFT = createAction('FAIL_DELETING_FORM_DRAFT');
export const resetFormDeletionState = () => ({
  type: RESET_FORM_DELETION_STATE
});
const succeedDeletingForm = () => ({
  type: SUCCEED_DELETING_FORM,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('deletionDialog.successMessage')
    }
  }
});
const succeedDeletingFormDraft = () => ({
  type: SUCCEED_DELETING_FORM_DRAFT,
  meta: {
    notification: {
      type: 'success',
      message: I18n.text('editor.form.deleteDraftSuccess')
    }
  }
});
const failedDeletingFormDraft = () => ({
  type: FAIL_DELETING_FORM_DRAFT,
  meta: {
    notification: {
      type: 'error',
      message: I18n.text('editor.form.deleteDraftError')
    }
  }
});
const failDeletingForm = ({
  reason = FormErrors.UNKNOWN
}) => ({
  type: FAIL_DELETING_FORM,
  meta: {
    notification: {
      type: 'danger',
      title: I18n.text('deletionDialog.deletionFailureHeading'),
      message: I18n.text(`deletionDialog.deletionFailureMessages.${reason}`)
    }
  }
});
export function deleteForm(guid, formType) {
  return (dispatch, getState) => {
    dispatch({
      type: REQUEST_FORM_DELETION
    });
    let promise;
    switch (formType) {
      case FormTypes.CAPTURED:
        promise = deleteCollectedForm(guid);
        break;
      case FormTypes.FLOW:
        promise = LeadFlowsService.deleteForm(guid);
        break;
      default:
        promise = FormsService.deleteForm(guid);
    }
    promise.then(() => {
      const state = getState();
      const redirectUrl = getRedirectUrl(state);
      const isExternalEditor = getIsExternalEditor(state);
      dispatch(succeedDeletingForm());
      if (!isExternalEditor && !isEmpty(redirectUrl)) {
        window.location.href = redirectUrl;
      }
    }, ({
      xhr
    }) => {
      switch (xhr.status) {
        case 0:
          dispatch(failDeletingForm({
            reason: FormErrors.NO_NETWORK
          }));
          return;
        case 404:
          dispatch(failDeletingForm({
            reason: FormErrors.NOT_FOUND
          }));
          return;
        default:
          dispatch(failDeletingForm(parseFormError(xhr)));
      }
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export function deleteFormDraft(guid) {
  return dispatch => {
    removeFormDraft(guid).then(() => {
      trackEditorInteraction(DELETE_UNPUBLISHED_CHANGES);
      dispatch(succeedDeletingFormDraft());
      dispatch(fetchFormDefinition(guid));
    }, () => {
      dispatch(failedDeletingFormDraft());
    }).catch(err => {
      setTimeout(() => {
        throw err;
      });
    });
  };
}
export const deleteForms = (guids = []) => dispatch => {
  dispatch({
    type: REQUEST_FORM_DELETION
  });
  return FormsService.deleteForms(guids).then(() => {
    dispatch(succeedDeletingForm());
  }, xhr => {
    dispatch(failDeletingForm(parseFormError(xhr)));
  });
};